import { default as annual_45reportsJslz7D9L4tMeta } from "/home/runner/work/WebSite/WebSite/pages/about-us/annual-reports.vue?macro=true";
import { default as awardsRrVWKl0yHCMeta } from "/home/runner/work/WebSite/WebSite/pages/about-us/awards.vue?macro=true";
import { default as company_45profileuM9LV32OE4Meta } from "/home/runner/work/WebSite/WebSite/pages/about-us/company-profile.vue?macro=true";
import { default as executive_45managementep5p8qVgp9Meta } from "/home/runner/work/WebSite/WebSite/pages/about-us/executive-management.vue?macro=true";
import { default as organization_45charto5VkfRbWXBMeta } from "/home/runner/work/WebSite/WebSite/pages/about-us/organization-chart.vue?macro=true";
import { default as the_45board_45of_45directorsCmmnSFRnZxMeta } from "/home/runner/work/WebSite/WebSite/pages/about-us/the-board-of-directors.vue?macro=true";
import { default as _91uid_93Q7v3iMO7l3Meta } from "/home/runner/work/WebSite/WebSite/pages/careers/[uid].vue?macro=true";
import { default as _91uid_933iyN3fJ6iXMeta } from "/home/runner/work/WebSite/WebSite/pages/careers/application/[uid].vue?macro=true";
import { default as after_45applying_45career1SRgtaBf8jMeta } from "/home/runner/work/WebSite/WebSite/pages/careers/application/after-applying-career.vue?macro=true";
import { default as indexIWpx3UrfmyMeta } from "/home/runner/work/WebSite/WebSite/pages/careers/index.vue?macro=true";
import { default as jobs_45openingXJC13dmKNBMeta } from "/home/runner/work/WebSite/WebSite/pages/careers/jobs-opening.vue?macro=true";
import { default as indexcNwljZU3HKMeta } from "/home/runner/work/WebSite/WebSite/pages/contact-us/index.vue?macro=true";
import { default as indexLYRmIEB19cMeta } from "/home/runner/work/WebSite/WebSite/pages/index.vue?macro=true";
import { default as _91uid_93nt6ZhWCUBbMeta } from "/home/runner/work/WebSite/WebSite/pages/news/[uid].vue?macro=true";
import { default as indexBg0vSMZKQIMeta } from "/home/runner/work/WebSite/WebSite/pages/news/index.vue?macro=true";
import { default as anti_45corruption3ITWasLijeMeta } from "/home/runner/work/WebSite/WebSite/pages/policies/anti-corruption.vue?macro=true";
import { default as cookieiKXfnNFsd6Meta } from "/home/runner/work/WebSite/WebSite/pages/policies/cookie.vue?macro=true";
import { default as pdpaz8MBqUY4yuMeta } from "/home/runner/work/WebSite/WebSite/pages/policies/pdpa.vue?macro=true";
import { default as products_45and_45servicesdjHgRE4c1lMeta } from "/home/runner/work/WebSite/WebSite/pages/products-and-services.vue?macro=true";
import { default as environmentalRnn723CsvsMeta } from "/home/runner/work/WebSite/WebSite/pages/sustainability/environmental.vue?macro=true";
import { default as governanceDujyfjj6CYMeta } from "/home/runner/work/WebSite/WebSite/pages/sustainability/governance.vue?macro=true";
import { default as socialEtg4aUI87EMeta } from "/home/runner/work/WebSite/WebSite/pages/sustainability/social.vue?macro=true";
export default [
  {
    name: "about-us-annual-reports___en",
    path: "/en/about-us/annual-reports",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/about-us/annual-reports.vue")
  },
  {
    name: "about-us-annual-reports___th",
    path: "/about-us/annual-reports",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/about-us/annual-reports.vue")
  },
  {
    name: "about-us-awards___en",
    path: "/en/about-us/awards",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/about-us/awards.vue")
  },
  {
    name: "about-us-awards___th",
    path: "/about-us/awards",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/about-us/awards.vue")
  },
  {
    name: "about-us-company-profile___en",
    path: "/en/about-us/company-profile",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/about-us/company-profile.vue")
  },
  {
    name: "about-us-company-profile___th",
    path: "/about-us/company-profile",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/about-us/company-profile.vue")
  },
  {
    name: "about-us-executive-management___en",
    path: "/en/about-us/executive-management",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/about-us/executive-management.vue")
  },
  {
    name: "about-us-executive-management___th",
    path: "/about-us/executive-management",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/about-us/executive-management.vue")
  },
  {
    name: "about-us-organization-chart___en",
    path: "/en/about-us/organization-chart",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/about-us/organization-chart.vue")
  },
  {
    name: "about-us-organization-chart___th",
    path: "/about-us/organization-chart",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/about-us/organization-chart.vue")
  },
  {
    name: "about-us-the-board-of-directors___en",
    path: "/en/about-us/the-board-of-directors",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/about-us/the-board-of-directors.vue")
  },
  {
    name: "about-us-the-board-of-directors___th",
    path: "/about-us/the-board-of-directors",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/about-us/the-board-of-directors.vue")
  },
  {
    name: "careers-uid___en",
    path: "/en/careers/:uid()",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/careers/[uid].vue")
  },
  {
    name: "careers-uid___th",
    path: "/careers/:uid()",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/careers/[uid].vue")
  },
  {
    name: "careers-application-uid___en",
    path: "/en/careers/application/:uid()",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/careers/application/[uid].vue")
  },
  {
    name: "careers-application-uid___th",
    path: "/careers/application/:uid()",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/careers/application/[uid].vue")
  },
  {
    name: "careers-application-after-applying-career___en",
    path: "/en/careers/application/after-applying-career",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/careers/application/after-applying-career.vue")
  },
  {
    name: "careers-application-after-applying-career___th",
    path: "/careers/application/after-applying-career",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/careers/application/after-applying-career.vue")
  },
  {
    name: "careers___en",
    path: "/en/careers",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/careers/index.vue")
  },
  {
    name: "careers___th",
    path: "/careers",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/careers/index.vue")
  },
  {
    name: "careers-jobs-opening___en",
    path: "/en/careers/jobs-opening",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/careers/jobs-opening.vue")
  },
  {
    name: "careers-jobs-opening___th",
    path: "/careers/jobs-opening",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/careers/jobs-opening.vue")
  },
  {
    name: "contact-us___en",
    path: "/en/contact-us",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/contact-us/index.vue")
  },
  {
    name: "contact-us___th",
    path: "/contact-us",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/contact-us/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/index.vue")
  },
  {
    name: "index___th",
    path: "/",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/index.vue")
  },
  {
    name: "news-uid___en",
    path: "/en/news/:uid()",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/news/[uid].vue")
  },
  {
    name: "news-uid___th",
    path: "/news/:uid()",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/news/[uid].vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/news/index.vue")
  },
  {
    name: "news___th",
    path: "/news",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/news/index.vue")
  },
  {
    name: "policies-anti-corruption___en",
    path: "/en/policies/anti-corruption",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/policies/anti-corruption.vue")
  },
  {
    name: "policies-anti-corruption___th",
    path: "/policies/anti-corruption",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/policies/anti-corruption.vue")
  },
  {
    name: "policies-cookie___en",
    path: "/en/policies/cookie",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/policies/cookie.vue")
  },
  {
    name: "policies-cookie___th",
    path: "/policies/cookie",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/policies/cookie.vue")
  },
  {
    name: "policies-pdpa___en",
    path: "/en/policies/pdpa",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/policies/pdpa.vue")
  },
  {
    name: "policies-pdpa___th",
    path: "/policies/pdpa",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/policies/pdpa.vue")
  },
  {
    name: "products-and-services___en",
    path: "/en/products-and-services",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/products-and-services.vue")
  },
  {
    name: "products-and-services___th",
    path: "/products-and-services",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/products-and-services.vue")
  },
  {
    name: "sustainability-environmental___en",
    path: "/en/sustainability/environmental",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/sustainability/environmental.vue")
  },
  {
    name: "sustainability-environmental___th",
    path: "/sustainability/environmental",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/sustainability/environmental.vue")
  },
  {
    name: "sustainability-governance___en",
    path: "/en/sustainability/governance",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/sustainability/governance.vue")
  },
  {
    name: "sustainability-governance___th",
    path: "/sustainability/governance",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/sustainability/governance.vue")
  },
  {
    name: "sustainability-social___en",
    path: "/en/sustainability/social",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/sustainability/social.vue")
  },
  {
    name: "sustainability-social___th",
    path: "/sustainability/social",
    component: () => import("/home/runner/work/WebSite/WebSite/pages/sustainability/social.vue")
  }
]